import React from 'react';

import DriverDeliveryConversationChat from '../../DriverDeliveryConversationChat';

export function ChatModal({ open, onClose, delivery, driverId }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center p-4" style={{ zIndex: 2000 }}>
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative flex h-[80vh] w-full max-w-2xl min-h-0 overflow-hidden rounded-2xl bg-white shadow-2xl">
        <DriverDeliveryConversationChat delivery={delivery} driverId={driverId || delivery?.driver_id} onBackClick={onClose} />
      </div>
    </div>
  );
}
